import { Component } from '@angular/core';
import {finalize} from 'rxjs/operators';
import {ShoppingService} from '@app/shopping/shopping.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalDismissReasons, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {ScratchModel} from '../../models/scratch.model';
import {CouponModel} from '../../models/coupon.model';
import {CouponResumeModel} from '../../models/coupon-resume.model';
import {ChainService} from '@app/chain/chain.service';
import {DomainService} from '@app/core/domain/domain.service';
import {PlaceServiceBase} from '@app/core/places.service';

@Component({
  selector: 'app-shopping-cupons',
  templateUrl: './shopping-cupons.component.html',
  styleUrls: ['./shopping-cupons.component.scss']
})
export class ShoppingCuponsComponent {
  shopping: ShoppingModel;
  coupons: CouponResumeModel[] = [];
  selectedCoupon: CouponResumeModel;
  modalReference: NgbModalRef;
  isLoadingList = true;
  placeService: PlaceServiceBase;
  isShoppingDomain: boolean;

  constructor(private shoppingService: ShoppingService,
              private chainService: ChainService,
              private domainService: DomainService,
              private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal) {
    this.isShoppingDomain = domainService.isShoppingDomain();
    this.placeService = this.isShoppingDomain ? shoppingService : chainService;
    this.route.params.subscribe( params => {
      this.loadShoppingScratches(params.shoppingId);
    } );
  }

  navbarLeftText() {
    return `Exibindo ${this.coupons.length} Cupons eletrônicos`;
  }

  loadShoppingScratches(shoppingId: string) {
    this.placeService.getShopping(shoppingId)
      .pipe(finalize(() => {
      }))
      .subscribe(shopping => {
        this.shopping = shopping;
      }, error => {
        console.log(`shopping error: ${error}`);
      });

    this.placeService.getCoupons(shoppingId)
      .pipe(finalize(() => {
      }))
      .subscribe(coupons => {
        this.isLoadingList = false;
        coupons.forEach(coupom => {
          coupom.opened = false;
        });
        this.coupons = coupons;
      }, error => {
        console.log(`shopping error: ${error}`);
      });
  }

  getGiftsResume(coupom: CouponResumeModel) {
    let resume = '';
    coupom.gifts.forEach(gift => {
      resume += `${gift.quantity} ${gift.name}, `;
    });
    return resume.substring(0, resume.length - 2);
  }

  toggleCupom(item: any) {
    console.log('teste');
    item.opened = !item.opened;
  }

  openCouponsModal(content: any, coupom: CouponResumeModel) {
    this.selectedCoupon = coupom;
    this.modalReference = this.modalService.open(content, { windowClass: 'modal-centered modal-md' });
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-cupons/shopping-cupons.component.ts